<script>
/**
 * 品控 / 产能步骤条（01~08）
 * 栅格由 nh-base.css 的 .qc-process 控制（4 列）。
 */
export default {
  name: 'NhQcProcess',
  props: {
    steps: { type: Array, required: true }
  }
}
</script>

<template>
  <div class="qc-process">
    <div
      v-for="(step, i) in steps"
      :key="step.num"
      v-reveal="i % 4 || undefined"
      class="qc-step"
    >
      <div class="qc-num">{{ step.num }}</div>
      <h4>{{ step.title }}</h4>
      <p>{{ step.desc }}</p>
    </div>
  </div>
</template>
